
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'MM_DS',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/HD/MM_DS.vue